<template>
  <div class="input-form">
    <el-input v-model="oldFile" @change="change" :disabled="true"></el-input>
    <a href="javascript:void(0);" class="input">
      上传
      <input type="file" class="file" @change="getFile($event)" accept />
    </a>
  </div>
</template>

<script>
import { upload } from "common/js/api";

export default {
  props: ["data", "modelDat", "disableStatus"],

  data() {
    return {
      oldFile: "",
      newFile: "",
      file: "",
    };
  },

  methods: {
    change() {
      this.$emit("inputChange", {
        key: this.data.field,
        value: {
          oldFile: this.oldFile,
          newFile: this.newFile,
        },
      });
    },
    getFile(event) {
      this.file = event.target.files[0];

      if (this.file) {
        this.oldFile = this.file.name;
        this.submitForm(event);
      }
      //判断文件大于80M
      if (event.target.files[0].size > 80 * 1024 * 1024) {
        this.$message({
          message: "上传的文件不能大于80M",
          type: "warning",
        });
        this.file = "";
      }
    },

    async submitForm(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("file", this.file);
      let loadingInstance = this.$loading({ fullscreen: true });
      let a = setTimeout(() => {
        loadingInstance.close();
      }, 120000);
      const result = await upload(formData);
      clearTimeout(a);
      loadingInstance.close();
      this.oldFile = result.result.orignName;
      this.newFile = result.result.storePath;
      this.change();
    },
  },

  watch: {
    modelDat(newValue) {
      this.value = newValue;
    },
  },
};
</script>

<style scoped>
.input-form {
  position: relative;
}
/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  width: 70px;
  /* border-radius: 5px; */
  height: 30px;
  margin-top: 1px;
  vertical-align: top;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #7567a9;
  position: absolute !important;
  right: 0px;
  top: 10px;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
</style>
